export default __webpack_public_path__ + "static/media/Payfast-io-logo.d24d3c71.png";